// Theme toggle. The initial theme is applied by the inline script in <head>.
(() => {
  const toggle = document.querySelector('.l-theme');
  if (!toggle) return;
  const root = document.documentElement;
  const mq = matchMedia('(prefers-color-scheme: dark)');
  const isTheme = (v) => v === 'light' || v === 'dark';
  const current = () => (isTheme(root.dataset.theme) ? root.dataset.theme : (mq.matches ? 'dark' : 'light'));
  const label = () => {
    const text = `Switch to ${current() === 'dark' ? 'light' : 'dark'} theme`;
    toggle.setAttribute('aria-label', text);
    toggle.title = text;
  };
  label();
  // OS theme changed while open (matters only when no theme is saved)
  if (mq.addEventListener) mq.addEventListener('change', label);
  else if (mq.addListener) mq.addListener(label);
  toggle.addEventListener('click', () => {
    const next = current() === 'dark' ? 'light' : 'dark';
    root.dataset.theme = next;
    try { localStorage.setItem('d-theme', next); } catch (e) {}
    label();
  });
})();
